import * as React from 'react';
import { SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 44 44"
    fill="none"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m16.5 27.5 12.833-12.833M29.333 22v-7.333H22"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M34.833 36.669H9.167A3.666 3.666 0 0 1 5.5 33.002v-22a3.666 3.666 0 0 1 3.667-3.667h25.666a3.666 3.666 0 0 1 3.667 3.667v22a3.666 3.666 0 0 1-3.667 3.666Z"
    />
  </svg>
);
export default SvgComponent;
